import { CustomerType } from './customer-type.model';

export interface RollOffItem {
  id: number;
  projectTypes: ProjectType[];
  customerTypes: CustomerType[];
  materials: Materials[];
  containerLocations: Location[];
  containers: {
    [CustomerType.Residential]: DumpsterContainer[];
    [CustomerType.Contractor]: DumpsterContainer[];
    [CustomerType.Commercial]: DumpsterContainer[];
  };
  compactorSettings: {
    materials: CompactorMaterials[];
  };
}

export enum ProjectType {
  CleanOut = 'Clean out',
  Construction = 'Construction',
  Building = 'Building',
  Renovation = 'Renovation/remodel',
  Demolition = 'Demolition',
  Other = 'Other',
}

export enum Materials {
  ConstructionDemolition = 'Construction & Demolition (C&D)',
  Household = 'Household trash',
  Roofing = 'Roofing material',
  Cement = 'Cement/concrete',
  Wood = 'Wood',
  Metal = 'Metal',
  Recyclable = 'Recyclable material',
  Other = 'Other',
}

export enum CompactorMaterials {
  Cardboard = 'Cardboard',
  Trash = 'Trash',
  ZeroSort = 'Single stream recycling',
}

export enum Location {
  Street = 'Street',
  Driveway = 'Driveway',
  Yard = 'Yard or lawn',
  Other = 'Other',
}

export interface DumpsterContainer {
  id: number;
  name: string;
  dimensions: string;
  containerSize: number;
  containerDescription: string;
  tip: string;
  e2eDataValue?: string;
}

export enum DumpsterContainerType {
  OpenTop = 'openTop',
  Compactor = 'compactor',
}
